const METERS_PER_DEGREE_LATITUDE = 111320; // Meters per degree of latitude

/**
 * Checks if a point is within a square boundary of another point.
 * This is a simple approximation that doesn't calculate the actual distance.
 *
 * @param center - The center location with latitude and longitude
 * @param point - The point to check if it's within range
 * @param rangeInMeters - The range in meters to check (creates a square boundary)
 * @returns Boolean indicating if the point is within the square boundary
 */
export function isPointWithinGeofence(
  center: { lat: number; lng: number },
  point: { lat: number; lng: number },
  rangeInMeters: number,
): boolean {
  // Convert range from meters to degrees
  // 1 degree of latitude is approximately 111,320 meters
  const latRangeInDegrees = rangeInMeters / METERS_PER_DEGREE_LATITUDE;

  // 1 degree of longitude varies with latitude
  // At the equator, it's about 111,320 meters, but decreases as you move away from the equator
  const lngRangeInDegrees =
    rangeInMeters / (METERS_PER_DEGREE_LATITUDE * Math.cos(center.lat * (Math.PI / 180)));

  // Check if the point is within the square boundary
  const latInRange = Math.abs(point.lat - center.lat) <= latRangeInDegrees;
  const lngInRange = Math.abs(point.lng - center.lng) <= lngRangeInDegrees;

  // Point is in the geofence if both lat and lng are in range
  return latInRange && lngInRange;
}
